import React, {
    ReactNode,
    createContext,
    useContext,
    useLayoutEffect,
    useState,
} from "react";

interface LayoutContext {
    showSidebar: boolean;
    setShowSidebar: (arg0: boolean) => void;
}

const LayoutContext = createContext({});

interface Props {
    children?: ReactNode;
}

export const LayoutProvider = ({ children }: Props) => {
    const [showSidebar, setShowSidebar] = useState(true);

    return (
        <LayoutContext.Provider
            value={{
                showSidebar,
                setShowSidebar,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => {
    return useContext(LayoutContext) as LayoutContext;
};

export const useSidebar = (state: boolean) => {
    const { setShowSidebar } = useLayout();

    useLayoutEffect(() => {
        setShowSidebar(state);

        return () => {
            setShowSidebar(true);
        };
    });
};
